import React, { Component } from "react";
import { Link } from "react-router-dom";

export default class Sidebar extends Component {
  render() {
    return (
      <div>
        <h4 className="my-4">
          Pima COVID-19 Vaccination & Testing Centers Administration Panel
        </h4>
        <ul className="list-group list-group-flush">
          <li className="list-group-item">
            <Link to="/admin/testcenters">Test Centers</Link>
          </li>
          <li className="list-group-item">
            <Link to="/admin/vaccinecenters">Vaccine Centers</Link>
          </li>
        </ul>
      </div>
    );
  }
}
